export function modal() {
  var html = document.documentElement;
  var body = document.body;

  function lockScroll() {
    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
  }

  function unlockScroll() {
    html.style.removeProperty("overflow");
    body.style.removeProperty("overflow");
  }

  function findWrapper(modalId) {
    var wrappers = document.querySelectorAll(".c-modal__wrapper");
    for (var i = 0; i < wrappers.length; i++) {
      if (wrappers[i].getAttribute("data-modal") === modalId) {
        return wrappers[i];
      }
    }
    return null;
  }

  function showWrap(wrap) {
    wrap.style.display = "block";
    wrap.style.opacity = "0";
    wrap.style.transition = "opacity 200ms ease";
    requestAnimationFrame(function () {
      wrap.style.opacity = "1";
    });
    var container = wrap.querySelector(".c-modal__container");
    if (container) {
      container.scrollTop = 0;
    }
    lockScroll();
  }

  function hideWrap(wrap) {
    unlockScroll();
    wrap.style.transition = "opacity 200ms ease";
    wrap.style.opacity = "0";
    window.setTimeout(function () {
      wrap.style.display = "none";
      wrap.style.opacity = "";
      wrap.style.transition = "";
    }, 200);
  }

  document.addEventListener("click", function (e) {
    var trigger = e.target.closest(".c-modal__trigger");
    if (trigger) {
      e.preventDefault();
      var modalId = trigger.getAttribute("data-modal");
      if (modalId === null || modalId === "") {
        return;
      }
      var target = findWrapper(modalId);
      if (!target) {
        return;
      }
      showWrap(target);
      return;
    }

    var closer = e.target.closest(".c-modal__layer, .c-modal__close");
    if (closer) {
      e.preventDefault();
      var wrap = closer.closest(".c-modal__wrapper");
      if (wrap) {
        hideWrap(wrap);
      }
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") {
      return;
    }
    var wraps = document.querySelectorAll(".c-modal__wrapper");
    for (var j = 0; j < wraps.length; j++) {
      if (getComputedStyle(wraps[j]).display !== "none") {
        hideWrap(wraps[j]);
      }
    }
  });
}
